import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Service
import { OrderListService } from '../../service/order-list/order-list.service';

@Component({
	selector: 'app-order-list',
	templateUrl: './order-list.component.html',
	providers: [
		OrderListService,
		HttpModule
	]
})
export class OrderListComponent implements OnInit {

	private token;
	public orders: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "DataOrganizacao";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	order: FormGroup;

	constructor(fb: FormBuilder, private orderListService: OrderListService, private router: Router, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService) {
		this.token = localStorage.getItem('yara.token');
		this.order = fb.group({
			'Documento': '',
			'Numero': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.getOrders(this.order.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.getOrders(this.order.value, this.currentPage, false);
	}

	getOrders(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "DataOrganizacao";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.orderListService.getOrders(
			this.token,
			this.orderby,
			value.Documento,
			value.Numero,
			this.sort,
			page).subscribe(result => {
				if (result.Success) {
					this.orders = result.Result;
					this.resultCount = result.Count;
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
				
			});
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.getOrders(this.order.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/order/component/order-list/order-list.component.ts